import React from 'react';
import PropTypes from 'prop-types';
import renderRoutes from 'react-router-config/renderRoutes';
import { ConnectedRouter } from 'react-router-redux';
import { Provider } from 'react-redux';
import get from 'lodash/get';

import getRoutesWithStore from '../../react_router/react_router';
import Head from '../components/head/head';
import Footer from '../components/footer/footer';
import AmpHead from '../components/head/amp_head';
import FbiaHead from '../components/head/fbia_head';

import { TrackerProvider } from '../../utils/tracking/components';
import configuredTracker from '../../utils/tracking/configureTracker';

import Dwen from './pages/dwen/dwen_page';

// function addMoatPrebidHeader() {
//   const moatScript = window.top.document.createElement('script');

//   moatScript.setAttribute(
//     'src',
//     'https://z.moatads.com/mansuetoprebidheader15141606144/yi.js'
//   );

//   document.head.appendChild(moatScript);
//   window.moatYieldReady = function() {
//     console.log('header script added');
//   };
// }
function Root({ store, history, getRoutes, requestUrl }) {
  // addMoatPrebidHeader();
  const state = store.getState();
  const amp = get(state, 'config.amp');
  const fbia = get(state, 'config.fbia');
  let isBlank = false;
  if (amp) {
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <html amp="" lang="en-US" className="fonts-loaded">
            <AmpHead />
            {renderRoutes(getRoutes(store))}
          </html>
        </ConnectedRouter>
      </Provider>
    );
  }

  if (fbia) {
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <html lang="en-US" prefix="op: http://media.facebook.com/op#">
            <FbiaHead />
            {renderRoutes(getRoutes(store))}
          </html>
        </ConnectedRouter>
      </Provider>
    );
  }

  //   if (requestUrl.includes('fcw/AC_Hotels_by_Marriott')) {
  //     isBlank = true;
  //   }

  if (requestUrl.includes('/dwen') || requestUrl.includes('/DWEN')) {
    isBlank = true;

    if (isBlank) {
      return (
        <Provider store={store}>
          <ConnectedRouter history={history}>
            <TrackerProvider tracker={configuredTracker}>
              <html lang="en-US" id="dwen">
                <Head />
                <Dwen />
                {/* {renderRoutes(getRoutesWithStore(store))} */}
                <Footer />
              </html>
            </TrackerProvider>
          </ConnectedRouter>
        </Provider>
      );
    }
  }

  // if (isBlank) {
  //   // ONLY WORKS FOR AC HOTELS AT THE MOMENT!
  //   return (
  //     <Provider store={store}>
  //       <ConnectedRouter history={history}>
  //         <TrackerProvider tracker={configuredTracker}>
  //           <html lang="en-US">
  //             <Head />
  //             <style
  //               dangerouslySetInnerHTML={{
  //                 __html: `
  //                   body {
  //                     padding-top: 0px !important;
  //                   }
  //                 `
  //               }}
  //             />
  //             {/* <div
  //               style={{
  //                 position: 'relative',
  //                 width: 'auto',
  //                 padding: '0 0 407.14%',
  //                 height: 0,
  //                 top: 0,
  //                 left: 0,
  //                 bottom: 0,
  //                 right: 0,
  //                 margin: 0,
  //                 border: '0 none'
  //               }}
  //               id="experience-5e2dc9f9a84d3"
  //               data-aspectRatio="0.24561404"
  //             >
  //               <iframe
  //                 allowfullscreen
  //                 src="//view.ceros.com/inc/fc-ac-hotels?heightOverride=5700"
  //                 style={{
  //                   position: 'absolute',
  //                   top: 0,
  //                   left: 0,
  //                   bottom: 0,
  //                   right: 0,
  //                   margin: 0,
  //                   padding: 0,
  //                   border: '0 none',
  //                   height: '1px',
  //                   width: '1px',
  //                   minHeight: '100%',
  //                   minWidth: '100%'
  //                 }}
  //                 frameborder="0"
  //                 class="ceros-experience"
  //                 scrolling="no"
  //               />
  //             </div>
  //             <script
  //               type="text/javascript"
  //               src="//view.ceros.com/scroll-proxy.min.js"
  //               data-ceros-origin-domains="view.ceros.com"
  //             /> */}
  //             <div
  //               style={{
  //                 position: 'relative',
  //                 width: 'auto',
  //                 padding: '0 0 51.43%',
  //                 height: '100vh !important',
  //                 top: 0,
  //                 left: 0,
  //                 bottom: 0,
  //                 right: 0,
  //                 margin: 0,
  //                 border: '0 none'
  //               }}
  //               id="experience-5e2dc9f9a84d3"
  //               data-aspectRatio="1.94444444"
  //               data-mobile-aspectRatio="0.5625"
  //             >
  //               <iframe
  //                 allowfullscreen
  //                 src="//view.ceros.com/inc/fc-ac-hotels"
  //                 style={{
  //                   position: 'absolute',
  //                   top: 0,
  //                   left: 0,
  //                   bottom: 0,
  //                   right: 0,
  //                   margin: 0,
  //                   padding: 0,
  //                   border: '0 none',
  //                   height: '100vh !important',
  //                   width: '100%'
  //                 }}
  //                 frameborder="0"
  //                 class="ceros-experience"
  //               />
  //             </div>
  //             <script
  //               type="text/javascript"
  //               src="//view.ceros.com/scroll-proxy.min.js"
  //               data-ceros-origin-domains="view.ceros.com"
  //             />
  //           </html>
  //         </TrackerProvider>
  //       </ConnectedRouter>
  //     </Provider>
  //   );
  // }
  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <TrackerProvider tracker={configuredTracker}>
          <html lang="en-US">
            <Head />
            {renderRoutes(getRoutesWithStore(store))}
          </html>
        </TrackerProvider>
      </ConnectedRouter>
    </Provider>
  );
}

Root.defaultProps = {
  getRoutes: undefined,
  requestUrl: ''
};

Root.propTypes = {
  store: PropTypes.shape({}).isRequired,
  history: PropTypes.shape({}).isRequired,
  getRoutes: PropTypes.func,
  requestUrl: PropTypes.string
};

export default Root;
